import Section, {html, css} from './_section'

customElements.define('steens-form-section-sessions', class extends Section{

    get title(){ return '' }

    static get listeners(){ return {
        coll: {'sync': 'update'}
    }}

    renderControls(){return html`

        ${TEST_MODE?html`
        <b-paper color="blue">TEST MODE</b-paper>
        `:''}

        <b-grid cols="${this.coll.length}" cols-mobile="1" class="session">

        ${this.coll.map(model=>html`
            <b-paper outline ?disabled=${!model.isAvailable} ?active=${this.model==model}
                .model="${model}" @click=${this.changeSession}>

                <b-flex>
                    <h2>Session ${model.get('num')}</h2>
                    <b-text lg color="theme" ?hidden=${!model.get('rate')}>$${model.get('rate')}</b-text>
                </b-flex>
                <div>
                    ${model.dateRange}
                </div>

                <b-text sm italic muted="2">${model.get('detail')}</b-text>

                <b-text sm color="blue" ?hidden=${!model.get('discount')}>
                    Family/Team discount: <b>$${model.get('discount')}</b>
                    <b-text muted=2 xs>(per camper)</b-text>
                </b-text>
                
                <b-ribbon pos="right" ?hidden=${!model.isFull}>FULL</b-ribbon>

            </b-paper>
        `)}
        
        </b-grid>

        <!-- <div>

            <b>Family discount</b> = 2 or more siblings from the same family
            <br>
            <b>Team discount</b> = 7 or more from the same school

            <br>
            <b-text sm muted=2>
                If you qualify for a discount, we will apply it to your balance before we send final invoices in June. <i>Only one discount will be applied.</i>
            </b-text>

        </div> -->
    `}

    changeSession(e){
        // this.model = e.currentTarget.model
        this.emitEvent('change-session', {model: e.model})
    }

})